$(function(){
  var caseStudySwiper = new Swiper ('.js-caseStudySwiper', {
    effect: "fade",
    autoHeight: true,
  });

  caseStudySwiper.on('slideChange', function () {
      const index = caseStudySwiper.activeIndex;
      $(".js-changeCSArticle").removeClass("is-crt");
      $('.js-changeCSArticle[data-num="' + index + '"]').addClass("is-crt");
  });

  $(".js-changeCSArticle").on('click', function() {
    const index = $(this).attr("data-num");
    caseStudySwiper.slideTo(index);
  });


  var coverSwiper = new Swiper ('.js-coverSlider', {
    effect: "fade",
    autoHeight: true,
    loop: true,
    speed: 2000,
    allowTouchMove: false,
    autoplay: {
      delay: 4000,
    },
    on: {
    init: function () {
      console.log('swiper initialized');
    },
  },
  });

  coverSwiper.on('slideChange', function () {
      const index = coverSwiper.activeIndex;
      $(".p-topCoverArea").attr("data-active-slide", index);
  });

});

$('.js-arrangeModal').modaal({
  type: 'image',
  accessible_title: 'オンライン相談でお仕立てしたリングの画像',
});

$(".js-flowOpen .p-onlineFlowListItem__img, .js-flowOpen .p-onlineFlowListItem__title").on("click", function(){
  $(this).closest(".js-flowOpen").addClass("is-open");
  $(this).closest(".js-flowOpen").find(".p-onlineFlowListItem__details").slideDown();
});

$(".js-flowClose").on("click", function(){
  $(this).closest(".js-flowOpen").removeClass("is-open");
  $(this).closest(".js-flowOpen").find(".p-onlineFlowListItem__details").slideUp();
});